import microsites from "./microsites";

export const MICROSITE_NAMESPACE = `microsites`;

export default microsites;
